// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
     backend_get_url: "https://script.google.com/macros/s/AKfycbwggLU62H_sD14gD4TK_mH6d6dozjOr1MjhBFSPS9ZFQ21fUH8/exec"
};
